import * as React from "react";
import { useFetchCLByPrescription } from "../../../../../../../../../hooks/modules/EcommContent/ContactLensesEcommContent/hooks/use-fetch-cl-by-prescription.js";
import { useProductData } from "../../../../../../../../../../../../context/context/product-context-hooks.js";
import { useCLEcommContext } from "../../../../../../../../../context/modules/EcommContent/ContactLensesEcommContent/context/CLEcommContext.js";
const useFetchCLForActiveVariant = ({ eyeSide }) => {
  const { activeVariant } = useProductData();
  const { state, selectors } = useCLEcommContext();
  const { prescription } = state.configurations[eyeSide];
  const rxColumnValidations = selectors.isRxColumnValid(state);
  const isValid = rxColumnValidations[eyeSide];
  const { isEnabled } = state.configurator[eyeSide];
  const fetchCLByPrescription = useFetchCLByPrescription({ eyeSide });
  React.useEffect(() => {
    if (!isValid || !isEnabled) {
      return;
    }
    fetchCLByPrescription(prescription);
  }, [fetchCLByPrescription, activeVariant, prescription, isEnabled, isValid]);
};
export {
  useFetchCLForActiveVariant
};
//# sourceMappingURL=use-fetch-cl-for-active-variant.js.map
